import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: "SCEGLI L'ARGOMENTO",
  description: "Trova rapidamente l'unità che stai insegnando."
}, {
  number: '02',
  title: 'APRI CIÒ CHE TI SERVE',
  description: 'Teoria, attività, schede, verifiche e soluzioni sono già organizzate.'
}, {
  number: '03',
  title: 'USA IL MATERIALE IN CLASSE',
  description: 'Stampa, proietta o integra le risorse nella tua lezione.'
}];
export function HowItWorks() {
  return <section className="w-full bg-paper px-5 py-6 sm:py-12" data-id="element-131" data-mp="qi1u1w9laccr">
      <div className="mx-auto max-w-5xl" data-id="element-132" data-mp="cshsuuvnpn5k">
        <div className="mx-auto max-w-2xl text-center" data-id="element-133" data-mp="crgfgjr64oko">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-134" data-mp="gt1ofu0l0ipl">
            Dalla ricerca alla lezione in 3 semplici passaggi
          </h2>
        </div>

        <div className="mt-6 flex flex-col gap-3 sm:mt-10 md:flex-row md:gap-6" data-id="element-135" data-mp="199m8lucw0k76">
          {steps.map((step, i) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex flex-1 items-center gap-4 rounded-xl bg-white p-4 shadow-sm sm:flex-col sm:p-6 sm:text-center" data-id="element-136" data-mp="2rkwgb5zkupql" data-mpi={i}>
              <span className="font-serif-display text-3xl font-bold text-cobalt sm:text-4xl" data-id="element-137" data-mp="3ab4cf44v0fxa">
                {step.number}
              </span>
              <div data-id="element-138" data-mp="36cwuw72knal1">
                <h3 className="text-sm font-bold text-ink sm:mt-2 sm:text-lg" data-id="element-139" data-mp="3ka3bpw3qiz7m">{step.title}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-ink/70 sm:mt-2 sm:text-sm" data-id="element-140" data-mp="3fb8rcpq4d2le">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-6 text-center sm:mt-8" data-id="element-141" data-mp="1ky0uksil2gx4">
          <p className="text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-142" data-mp="1kzbzwwrofwqc">Scegli. Apri. Insegna.</p>
          <p className="mt-1 text-sm text-ink/70 sm:mt-2 sm:text-base" data-id="element-143" data-mp="3l1jw0mhv8tdq">
            Non partire più dalla ricerca. Parti dalla lezione.
          </p>
        </div>
      </div>
    </section>;
}